import React from "react";
import { getOperatingHours } from "../utils/get_operating_hours";
import { BookingHour } from "@/data";
import { useI18n } from "@/lib/i18n/i18n_provider";
import { useMediaQuery } from "@/hooks";

interface HourDetailsProps {
  bookingHours: BookingHour[];
}

const getHoursStyles = (isMobile: boolean) => ({
  display: "grid",
  gridTemplateColumns: isMobile ? "1fr max-content" : "max-content 1fr",
  gap: isMobile ? "0 20px" : "0 40px",
});

const HourDetails = ({ bookingHours }: HourDetailsProps) => {
  const { fbt } = useI18n();
  const mq = useMediaQuery();

  const dayHours = getOperatingHours(bookingHours, fbt);

  return (
    <div className="hour-details">
      <h3>{fbt("Hours")}</h3>
      <div className="container-fluid p-0">
        <div style={getHoursStyles(mq.device === "mobile")}>
          {dayHours.map((dayHour) => {
            return (
              <React.Fragment key={dayHour.label}>
                <div>{dayHour.label}</div>
                <div>
                  {dayHour.open} - {dayHour.close}
                </div>
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default HourDetails;
